import { __assign } from "tslib";
import { getPrecisionForInterval, createDateFormatter, } from '@keen.io/charts-utils';
export var setChartSettings = function (_a) {
    var query = _a.query, componentSettings = _a.componentSettings;
    var interval = query.interval;
    var settings = {};
    var lineChartSettings = componentSettings;
    if (lineChartSettings.stackMode === 'percent') {
        settings = {
            yScaleSettings: {
                formatLabel: '${}%',
            },
        };
    }
    if (interval) {
        var precision = getPrecisionForInterval(interval);
        settings = __assign(__assign({}, settings), { tooltipSettings: {
                formatTime: createDateFormatter(precision, true),
            }, xScaleSettings: {
                type: 'time',
                precision: precision,
            } });
    }
    return settings;
};
